import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import { useUserInfor } from "../../../../../../Context/User";
import {
    AtualizarMotivoProblemaController,
    InserirMotivoProblemaController,
    ListarMotivoProblemaController,
} from "../../../../../../Controllers/AssistenciaTecnica/MotivoProblema/MotivoProblemasControllers";
import { IMotivoProblema } from "../../../../../../Interfaces/AssistenciaTecnica/MotivoProblema/MotivoProblemaInterfaces";
import UnForm from "../../../../../Form";
import { ChangeEvent, useState } from "react";

interface ICreateUpdateMotivoProblemaProps {
    motivoProblema?: IMotivoProblema;
    onSave?: () => void;
}

export default function CreateUpdateMotivoProblema(
    props: ICreateUpdateMotivoProblemaProps
) {
    const { UserInfor } = useUserInfor();
    const [idMotivoProblema, setIdMotivoProblema] = useState<number>(
        props.motivoProblema?.ID_MOTIVO_PROBLEMA ?? 0
    );

    function CreateUpdateMotivoProblemaSubmit(formData: IMotivoProblema) {
        let promise: Promise<IMotivoProblema[]>;

        if (props.motivoProblema) {
            promise = AtualizarMotivoProblemaController({
                ...formData,
                ID_MOTIVO_PROBLEMA: idMotivoProblema ?? 0,
                DS_MOTIVO_PROBLEMA: formData.DS_MOTIVO_PROBLEMA,
                FL_ATIVO: Boolean(formData.FL_ATIVO),
                ID_MOTIVO_PROBLEMA_PAI: formData.ID_MOTIVO_PROBLEMA_PAI,
                ID_USUARIO: UserInfor.ID_USUARIO ?? 0,
            });
        } else {
            promise = InserirMotivoProblemaController({
                ...formData,
                DS_MOTIVO_PROBLEMA: formData.DS_MOTIVO_PROBLEMA,
                FL_ATIVO: Boolean(formData.FL_ATIVO),
                ID_MOTIVO_PROBLEMA_PAI: formData.ID_MOTIVO_PROBLEMA_PAI,
                ID_USUARIO: UserInfor.ID_USUARIO ?? 0,
            });
        }

        promise.then(() => {
            props.onSave?.();
        });
    }

    function handleFormDataChange(e: ChangeEvent<HTMLInputElement>) {
        setIdMotivoProblema(Number(e.target.value));
    }

    return (
        <>
            {!props.motivoProblema && (
                <h5 className="text-center">Cadastre um Motivo Problema</h5>
            )}
            <UnForm
                handleSubmit={CreateUpdateMotivoProblemaSubmit}
                className="row"
            >
                <div className="col-md-4">
                    <UnForm.Input
                        name="DS_MOTIVO_PROBLEMA"
                        label="Motivo Problema"
                        defaultValue={props.motivoProblema?.DS_MOTIVO_PROBLEMA}
                        onChange={handleFormDataChange}
                    />
                </div>

                <div className="col-md-4">
                    <UnForm.LazySelect
                        controller={ListarMotivoProblemaController}
                        getKeyValue={(key) => key.ID_MOTIVO_PROBLEMA}
                        getDS={(ds) => ds.DS_MOTIVO_PROBLEMA}
                        name="ID_MOTIVO_PROBLEMA_PAI"
                        label="Motivo Problema Pai"
                        //defaultValue={props.motivoProblema?.ID_MOTIVO_PROBLEMA}
                    >
                        <option></option>
                    </UnForm.LazySelect>
                </div>

                <div className="col-md-4">
                    <UnForm.Switch
                        type="checkbox"
                        color="success"
                        label="Ativo"
                        labelPosition="top"
                        name="FL_ATIVO"
                        defaultChecked={props.motivoProblema?.FL_ATIVO}
                    />
                </div>
                <UnForm.SubmitButton
                    color={props.motivoProblema ? "primary" : "success"}
                    icon={props.motivoProblema ? faEdit : faPlus}
                    className="w-100 mt-3"
                >
                    {props.motivoProblema ? "Editar" : "Cadastrar"}
                </UnForm.SubmitButton>
            </UnForm>
        </>
    );
}
